<script setup>
import LandingPageLayout from '@/Layouts/LandingPageLayout.vue';
import { Link } from '@inertiajs/inertia-vue3';
import { ref } from 'vue';
import {
    CheckBadgeIcon,
    CurrencyDollarIcon,
    ChevronDownIcon,
} from '@heroicons/vue/24/outline'


const dataADs = [
    {name:'AD 2000-01-16 (c)',count:0.333333333333333},
    {name:'AD 2000-01-16 (b)',count:0.277777777777778},
    {name:'AD 2000-01-16 (e)',count:0.277777777777778},
    {name:'AD 2000-01-16 (d)',count:0.0555555555555556},
    {name:'AD 2000-01-16 (g)',count:0.0555555555555556},
];

const dataFARs = [
    {name:'FAR 91.411 Altimeter Test',count:0.255813953488372},
    {name:'FAR 91.413 Transponder Test',count:0.255813953488372},
    {name:'FAR 91.207(d) 12 Month ELT Check',count:0.232558139534884},
    {name:'FAR 91.207(c) ELT Batteries',count:0.162790697674419},
    {name:'FAR 91.409 Annual',count:0.0930232558139535},
];

const columns = [
    'Inspection','Percent'
]

const sortColumn = ref('Percent');
const ascending = ref(false);

const sortTable = (col) =>{
    if (sortColumn.value === col) {
        ascending.value = !ascending.value;
    } else {
        ascending.value = true;
        sortColumn.value = col;
    }

    let ascendingvar = ascending.value;

    return dataADs.sort(function(a, b) {
        console.log('ermm',a[col],b[col],a.name,b.name,col);
        if(col === 'Inspection'){
            if (a.name > b.name) {
                return ascendingvar ? 1 : -1
            } else if (a.name < b.name) {
                return ascendingvar ? -1 : 1
            }
            return 0;
        }else{
            if (a.count > b.count) {
                return ascendingvar ? 1 : -1
            } else if (a.count < b.count) {
                return ascendingvar ? -1 : 1
            }
            return 0;
        }
    });
}

const sortColumnFARs = ref('Percent');
const ascendingFARs = ref(false);

const sortTableFARs = (col) =>{
    if (sortColumnFARs.value === col) {
        ascendingFARs.value = !ascendingFARs.value;
    } else {
        ascendingFARs.value = true;
        sortColumnFARs.value = col;
    }

    let ascendingvar = ascendingFARs.value;

    return dataFARs.sort(function(a, b) {
        if(col === 'Inspection'){
            if (a.name > b.name) {
                return ascendingvar ? 1 : -1
            } else if (a.name < b.name) {
                return ascendingvar ? -1 : 1
            }
            return 0;
        }else{
            if (a.count > b.count) {
                return ascendingvar ? 1 : -1
            } else if (a.count < b.count) {
                return ascendingvar ? -1 : 1
            }
            return 0;
        }
    });
}

</script>

<template>
    <LandingPageLayout title="Case Studies - Missing ADs">
        <div class="isolate overflow-hidden">
            <div class="flow-root bg-gray-900 py-16 sm:pt-32 lg:pb-30">
                <div class="mx-auto max-w-7xl px-6 lg:px-8">
                    <div class="relative z-10">
                        <h1 class="mx-auto max-w-4xl text-center text-5xl font-bold tracking-tight text-white">Case Studies</h1>
                        <p class="mx-auto mt-4 max-w-2xl text-center text-lg leading-8 text-white/60">Missing ADs and FARs</p>
                    </div>
                    <div class="relative mx-auto mt-10 grid max-w-md grid-cols-1 gap-y-8 lg:mx-0 lg:-mb-14 lg:max-w-none lg:grid-cols-2">
                        <svg viewBox="0 0 1208 1024" aria-hidden="true" class="absolute -bottom-48 left-1/2 h-[64rem] -translate-x-1/2 translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] lg:-top-48 lg:bottom-auto lg:translate-y-0">
                            <ellipse cx="604" cy="512" fill="url(#d25c25d4-6d43-4bf9-b9ac-1842a30a4867)" rx="604" ry="512" />
                            <defs>
                                <radialGradient id="d25c25d4-6d43-4bf9-b9ac-1842a30a4867">
                                    <stop stop-color="#111827" />
                                    <stop offset="1" stop-color="#01b2ff" />
                                </radialGradient>
                            </defs>
                        </svg>
                        <div class="hidden lg:absolute lg:inset-x-px lg:bottom-0 lg:top-4 lg:block lg:rounded-t-2xl lg:bg-gray-800/80 lg:ring-1 lg:ring-white/10" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </div>
        <div class="relative isolate overflow-hidden bg-white py-24 sm:py-32">
            <div class="absolute -top-80 left-[max(6rem,33%)] -z-10 transform-gpu blur-3xl sm:left-1/2 md:top-20 lg:ml-20 xl:top-3 xl:ml-56" aria-hidden="true">
                <div class="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#edf4ff] to-[#599fff] opacity-30" style="clip-path: polygon(63.1% 29.6%, 100% 17.2%, 76.7% 3.1%, 48.4% 0.1%, 44.6% 4.8%, 54.5% 25.4%, 59.8% 49.1%, 55.3% 57.9%, 44.5% 57.3%, 27.8% 48%, 35.1% 81.6%, 0% 97.8%, 39.3% 100%, 35.3% 81.5%, 97.2% 52.8%, 63.1% 29.6%)" />
            </div>
            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <Link class="group flex font-semibold text-sm leading-6 text-slate-700 hover:text-slate-900 dark:text-slate-200 dark:hover:text-white mb-8" href="/case-studies"><svg viewBox="0 -9 3 24" class="overflow-visible mr-3 text-slate-400 w-auto h-6 group-hover:text-slate-600 dark:group-hover:text-slate-300"><path d="M3 0L0 3L3 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>Go back</Link>
                <div class="mx-auto max-w-2xl lg:mx-0">
                    <p class="text-lg font-semibold leading-8 tracking-tight text-indigo-600">Improve Safety</p>
                    <h1 class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Deep dive into the overdue ADs and FARs we found for customers in a 12 month period</h1>
                    <p class="mt-6 text-xl leading-8 text-gray-700">We investigated the projects we completed for customers over a 12 month period from August 2022 to August 2023 and studied our findings we shared with them, focusing on missed ADs and FARs.</p>
                </div>
                <div class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:mt-10 lg:max-w-none lg:grid-cols-12">
                    <div class="relative lg:order-last lg:col-span-5">
                        <svg class="absolute -top-[40rem] left-1 -z-10 h-[64rem] w-[175.5rem] -translate-x-1/2 stroke-gray-900/10 [mask-image:radial-gradient(64rem_64rem_at_111.5rem_0%,white,transparent)]" aria-hidden="true">
                            <defs>
                                <pattern id="e87443c8-56e4-4c20-9111-55b82fa704e3" width="200" height="200" patternUnits="userSpaceOnUse">
                                    <path d="M0.5 0V200M200 0.5L0 0.499983" />
                                </pattern>
                            </defs>
                            <rect width="100%" height="100%" stroke-width="0" fill="url(#e87443c8-56e4-4c20-9111-55b82fa704e3)" />
                        </svg>
                        <figure class="border-l border-indigo-600 pl-8">
                            <blockquote class="text-xl font-semibold leading-8 tracking-tight text-gray-900">
                                <p>“I just spoke to my mechanic about the details you need to complete your work, I would have never known anything was missing in my documentation if it wasn't for your service.  Plus you're modding the platform to fit CAAP recs?  Amazing.  Money well spent for sure, thanks Will.”</p>
                            </blockquote>
                        </figure>
                    </div>
                    <div class="max-w-xl text-base leading-7 text-gray-700 lg:col-span-7">
                        <p>Applicable FAA Airworthiness Directives (ADs) and Federal Aviation Regulations (FARs) are mandatory for all operators to comply with when flying in the US. They say that the FARs are written in blood, meaning that these exist to improve the safety of aviation. But did you know that if you have an incident with your airplane, the insurance company may request your logbooks to review them to make sure you were flying in compliance with these regulations, and if you were found to be out of compliance, they can deny coverage?</p>
                        <ul role="list" class="mt-8 max-w-xl space-y-8 text-gray-600">
                            <li class="flex gap-x-3">
                                <CheckBadgeIcon class="mt-1 h-5 w-5 flex-none text-indigo-600" aria-hidden="true" />
                                <span><strong class="font-semibold text-gray-900">Safety.</strong> The number one reason to make sure you are in compliance with applicable ADs and FARs is to improve the operational and mechanical safety of your aircraft.</span>
                            </li>
                            <li class="flex gap-x-3">
                                <CurrencyDollarIcon class="mt-1 h-5 w-5 flex-none text-indigo-600" aria-hidden="true" />
                                <span><strong class="font-semibold text-gray-900">Insurance.</strong> Failure to comply with applicable ADs and FARs can lead to flying self-insured without even knowing it.</span>
                            </li>
                        </ul>
                        <p class="mt-8">When we complete an onboarding project for a client, we diligently check through their AD Compliance Report from their shop and cross check against their records and applicable ADs in our system. Over a 12 month period from August 2022 to August 2023, we noticed that the customer was out of compliance with ~1.4 ADs on average. Additionally, we discovered the following instances of missed/overdue ADs that pertain to the twin piston pressurized Cessna fleet. This fleet is interesting in part due to the <a href="https://drs.faa.gov/browse/excelExternalWindow/B13936AEF8E883EF86256A340065CD46.0001" target="_blank" class="text-indigo-600">exhaust AD</a> that pertains to all of them and is difficult to keep track of in paper logbooks.</p>

                        <div class="mt-8 flow-root">
                            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    Twin Turbocharged Piston Cessna Segment -<br> Count of Exhaust ADs Missed / Total Segment
                                    <table class="min-w-full divide-y divide-gray-300">
                                        <thead>
                                        <tr>
                                            <th class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0" v-for="col in columns" v-on:click="sortTable(col)" scope="col">
                                                <span class="flex">{{col}}
                                                <ChevronDownIcon v-if="col === sortColumn" :class="[ascending ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform ml-2']" aria-hidden="true" />
                                                </span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-200">
                                        <tr v-for="item in dataADs" :key="item.name">
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{{ item.name }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ (item.count*100).toFixed(2) }}%</td>
                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">Total</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">100%</td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <p class="mt-8">We found similar discoveries with the FARs. Of note here is that more than one quarter of all of our clients who onboarded their aircraft into our platform discovered they were out of compliance for FAR 91.411 or FAR 91.413 (required for VFR and IFR).</p>
                        <div class="mt-8 flow-root">
                            <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                    All New Clients During Time Period -<br> Count of FARs Missed / Total Segment
                                    <table class="min-w-full divide-y divide-gray-300">
                                        <thead>
                                        <tr>
                                            <th class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0" v-for="col in columns" v-on:click="sortTableFARs(col)" scope="col">
                                                <span class="flex">{{col}}
                                                <ChevronDownIcon v-if="col === sortColumnFARs" :class="[ascendingFARs ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform ml-2']" aria-hidden="true" />
                                                </span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody class="divide-y divide-gray-200">
                                        <tr v-for="item in dataFARs" :key="item.name">
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{{ item.name }}</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ (item.count*100).toFixed(2) }}%</td>
                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        <tr>
                                            <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">Total</td>
                                            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">100%</td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <p class="mt-6">And half of the Cirrus customers over this time period were out of compliance with a CAPS related inspection which is mandatory for airworthiness.</p>
                        <h2 class="mt-8 text-2xl font-bold tracking-tight text-gray-900">Other interesting anomalies</h2>
                        <p class="mt-6">We found instances where mechanics were tracking old versions of ADs that were since revised. For example, AD 2016-07-04 was being actively complied with instead of the current version AD 2016-17-08.</p>
                        <p class="mt-6">We also found some ADs that were not applicable, indicated as such in the client's AD Compliance Report, and still was being regularly complied with, costing the client an unnecessary expense each time it was done.</p>
                        <p class="mt-6">Here are a few interesting items we found too:</p>
                        <ul role="list" class="mt-8 max-w-xl space-y-8 text-gray-600">
                            <li class="flex gap-x-3">
                                <span>Example of typos: “AD 2016-17-08 is been written in your maintenance entries as AD 16-17-18."</span>
                            </li>
                            <li class="flex gap-x-3">
                                <span>Example of a helicopter AD being mentioned against an airplane: "AD 2018-03-03 R1 is being written in your maintenance entries as AD 2018-03-01 R1, which is an AD referring to AB139 and AW139 helicopters."</span>
                            </li>
                            <li class="flex gap-x-3">
                                <span>Example of wrong make and wrong due intervals: "AD 2005-05-02 is mentioned in a recent 100 Hour inspection. This AD pertains to McDonnel Douglas MD-90-30 airplanes. In this same entry, AD 2018-03-03 R1 is mentioned in your AD compliance report as being due at 7,000 TTAF, but we believe it is due at 15,000 TTAF and are tracking it as such.”</span>
                            </li>
                        </ul>
                        <h2 class="mt-8 text-2xl font-bold tracking-tight text-gray-900">Conclusions</h2>
                        <p class="mt-6">The data indicates that a over 25% of the clients that signed up in this 12 month period were unknowingly flying out of airworthiness requirements mandated by the FARs. And the majority of clients that signed up in this 12 month period were unknowingly flying out of airworthiness requirements mandated by either the FARs or the FAA ADs.</p>
                        <h2 class="mt-8 text-2xl font-bold tracking-tight text-gray-900">Ready to take steps to prevent this from happening to you?</h2>
                        <p class="mt-6">These inspections are important and can save your life. We can help you and your shop do a better job of keeping up with existing FARs as well as existing and new ADs released by the FAA. <Link href="/contact" class="text-indigo-600">Reach out to us today to get started.</Link></p>
                    </div>
                </div>
                <Link class="group flex font-semibold text-sm leading-6 text-slate-700 hover:text-slate-900 dark:text-slate-200 dark:hover:text-white mt-10" href="/case-studies"><svg viewBox="0 -9 3 24" class="overflow-visible mr-3 text-slate-400 w-auto h-6 group-hover:text-slate-600 dark:group-hover:text-slate-300"><path d="M3 0L0 3L3 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>Go back</Link>
            </div>
        </div>

    </LandingPageLayout>


</template>
